const TZ = "Europe/Madrid";

const fmt = (opts) => (value) => (value ? new Intl.DateTimeFormat("es-ES", { timeZone: TZ, ...opts }).format(new Date(value)) : "");

export const fmtDate = fmt({ day: "numeric", month: "long", year: "numeric" });
export const fmtDateTime = fmt({ day: "numeric", month: "short", hour: "2-digit", minute: "2-digit" });
export const fmtTime = fmt({ hour: "2-digit", minute: "2-digit" });
export const todayLong = () => fmt({ weekday: "long", day: "numeric", month: "long", year: "numeric" })(new Date());

const rtf = new Intl.RelativeTimeFormat("es", { numeric: "auto" });

export const timeAgo = (value) => {
  if (!value) return "";
  const diff = (new Date(value).getTime() - Date.now()) / 1000;
  const abs = Math.abs(diff);
  if (abs < 60) return diff < 0 ? "ahora mismo" : "en unos segundos";
  if (abs < 3600) return rtf.format(Math.round(diff / 60), "minute");
  if (abs < 86400) return rtf.format(Math.round(diff / 3600), "hour");
  if (abs < 86400 * 7) return rtf.format(Math.round(diff / 86400), "day");
  return fmtDate(value);
};

export const toLocalInput = (iso) => {
  if (!iso) return "";
  const d = new Date(iso);
  return new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 16);
};

export const fromLocalInput = (value) => (value ? new Date(value).toISOString() : null);
